import React, { useState, useEffect } from "react";

const Send = ({ templates = [], contact, context = {}, state, setState }) => {
    const [selectedtemplateindex, setSelectedtemplateindex] = useState(0);
    const [selectednumberindex, setSelectednumberindex] = useState(0);

    const [templatecontent, setTemplatecontent] = useState('');

    const [result, setResult] = useState('');

    function removehyperlinks(text) {
        return text?.replace(/(\d)(?=\d)/g, '$1\u200B');
    }

    useEffect(() => {
        if (!templates || templates.length === 0) {
            setTemplatecontent('Please make sure to set a template in the settings section.')
            return;
        }

        const currentTemplate = templates[selectedtemplateindex];
        if (!currentTemplate || !currentTemplate.content) {
            setTemplatecontent('Please make sure to set a template in the settings section.')
            return
        }

        let content = currentTemplate.content;

        const mergedContext = {
            ...context,
            recipient: contact.numbers[selectednumberindex]?.name || contact.name,
            clientname: contact?.name || '',
            username: state.user.username || '',
            projectname: removehyperlinks(context.projectname)
        };
        Object.entries(mergedContext).forEach(([key, value]) => {
            const regex = new RegExp(`\\{${key}\\}`, 'g');
            content = content.replace(regex, value ?? '');
        });

        setTemplatecontent(content);
    }, [selectedtemplateindex, selectednumberindex]);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handleWhatsApp = () => {
        if (!contact || !contact.numbers || !contact.numbers[selectednumberindex]) {
            setResult('No phone number found')
            return
        }

        const selected = contact.numbers[selectednumberindex];
        if (!selected.number) {
            setResult('Number is invalid')
            return
        }

        const cleanNumber = selected.number.replace(/\D/g, "");
        const encodedText = encodeURIComponent(templatecontent);
        window.open(`https://wa.me/${cleanNumber}?text=${encodedText}`, "_blank");
        // window.open(`https://api.whatsapp.com/send?phone=${cleanNumber}&text=${encodedText}`, "_blank");
    };

    const handleSMS = () => {
        if (!contact || !contact.numbers || !contact.numbers[selectednumberindex]) {
            setResult("No phone number selected for SMS");
            return;
        }

        const selected = contact.numbers[selectednumberindex];
        if (!selected.number) {
            setResult("Selected number is invalid for SMS");
            return;
        }

        const cleanNumber = selected.number.replace(/\D/g, "");
        window.open(`sms:${cleanNumber}?&body=${encodeURIComponent(templatecontent)}`);
    };

    const handleEmail = () => {
        if (!contact || !contact.email) {
            setResult("No email found for this contact");
            return;
        }

        const email = contact.email;
        const subject = encodeURIComponent("Receipt");
        const body = encodeURIComponent(templatecontent);

        const link = document.createElement("a");
        link.href = `mailto:${email}?subject=${subject}&body=${body}`;
        link.click();

        setResult("Email should open. If not, check your browser settings.");
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(templatecontent);
            setResult('Copied to clipboard')
            return
        } catch {
            setResult('Failed to copy')
            return
        }
    };

    return (
        <div className="modal_body">
            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>Template</div>
                </div>
                <div className='modal_rowsection'>
                    <select
                        className='modal_select'
                        value={selectedtemplateindex}
                        onChange={e => setSelectedtemplateindex(Number(e.target.value))}>
                        {templates.map((t, i) => (
                            <option key={'template' + i} value={i}>{t.content.slice(0, 30)}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>Contact</div>
                </div>
                <div className='modal_rowsection'>
                    {contact?.name}
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <div className='modal_label'>Number</div>
                </div>
                <div className='modal_rowsection'>
                    {contact?.numbers?.length > 0 && (
                        <select
                            className='modal_select'
                            value={selectednumberindex}
                            onChange={(e) => setSelectednumberindex(e.target.value)}
                        >
                            {contact.numbers.map((number, index) => (
                                <option key={'number' + index} value={index}>
                                    {number.name + " " + number.number}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    {contact?.email && (
                        <div className="send_info">✉️ {contact.email}</div>
                    )}
                </div>
            </div>

            <div className='modal_row'>
                <div className='modal_rowsection'>
                    <textarea
                        className="modal_textarea"
                        value={templatecontent}
                        onChange={(e) => setTemplatecontent(e.target.value)}
                        rows={6}
                        placeholder=""
                    />
                </div>
            </div>

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleWhatsApp}>📱 WhatsApp</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleEmail}>📧 Email</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleCopy}>📋 Copy</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleSMS}>💬 SMS</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Send;